import { useQuery } from "react-query";
import { uncoveryApi } from "../..";

const fetchAllEntities = async ({ page, pageSize, sorting }) => {
  const sortBy = sorting?.[0]?.id || "lastCartographyDate";
  const orderBy = sorting?.[0]?.desc ? "desc" : "asc";

  const query = `/entities/overview?page=${page}&pageSize=${pageSize}&sortBy=${sortBy}&orderBy=${orderBy}`;
  const { data } = await uncoveryApi.get(query);

  return {
    entities: data.data.entities,
    totalEntities: data.data.totalEntities,
    totalOpenIssues: data.data.totalOpenIssues,
    totalActiveAssets: data.data.totalActiveAssets,
    highestScore: data.data.globalHighestSeverityScore,
    hasNextPage: data.data.hasNextPage,
  };
};

export default function useFetchAllEntities({
  page = 1,
  pageSize = 10,
  sorting = [{ id: "lastCartographyDate", desc: true }],
  intervalMs = false,
} = {}) {
  return useQuery(
    ["entitiesOverview", page, pageSize],
    () =>
      fetchAllEntities({
        page,
        pageSize,
        sorting,
      }),
    {
      refetchInterval: intervalMs,
      keepPreviousData: true,
      enabled: typeof page === "number" && pageSize > 0 && page >= 1,
      staleTime: 5 * 60 * 1000, // Data is fresh for 5 minutes
      cacheTime: 10 * 60 * 1000, // Cache persists for 10 minutes
      refetchOnMount: false, // Prevent refetch on component mount
      refetchOnWindowFocus: false, // Prevent refetch on window focus
      select: (data) => {
        const entities = [...data.entities];
        const [sort] = sorting;

        if (sort) {
          entities.sort((a, b) => {
            const aValue = a[sort.id];
            const bValue = b[sort.id];

            if (aValue == null) return sort.desc ? 1 : -1;
            if (bValue == null) return sort.desc ? -1 : 1;

            if (typeof aValue === "number") {
              return sort.desc ? bValue - aValue : aValue - bValue;
            }
            return sort.desc
              ? String(bValue).localeCompare(String(aValue))
              : String(aValue).localeCompare(String(bValue));
          });
        }

        return {
          ...data,
          entities,
        };
      },
    }
  );
}
